const Color = {
    // главный цвет во всем макете
    PRIMARY: '#F5F5F5',
    // цвет,призванный контрастировать с главным, цвет для акцента
    SECONDARY: '#0032A0',
    // цвет текста главный (обычно черный)
    TEXT_PRIMARY: '#000000',
    // цвет текста инвертированный(для темного фона)
    TEXT_SECONDARY: '#FFFFFF',
    // цвет для обозначения события наведения
    HOVER: '',
    // цвет для обозначения события нажатия
    ACTIVE: '#002679',
};

export default Color;
